import { Box, Container } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductWizardState from '../../model/ProductWizardState';
import { productWizardActions } from '../../model/store';
import CartSumBar from '../Cart/CartSumBar/CartSumBar';
import IkzeExtendedEntrepreneurDepositAgreement, {
  IkzeExtendedEntrepreneurDepositAgreementForm,
} from '../IkzeExtendedEntrepreneurDeposit/IkzeExtendedEntrepreneurDepositAgreement';
import { ProductWizardTitle } from '../ProductWizard/ProductWizardTitle/ProductWizardTitle';
import Screen from '../ProductWizard/Screen';
import { ProductType } from 'cart-model';
import { useTranslation } from 'react-i18next';

import useStyles from './TransferIkzeEntrepreneur.style';

const TransferIkzeEntrepreneur: React.FC = () => {
  const c = useStyles({});
  const dispatch = useDispatch();
  const productType = useSelector((state: ProductWizardState) => state.uiState.productType);
  const [ikzeFormValid, setIkzeFormValid] = useState(true);
  const [t] = useTranslation('ikze-extended-entrepreneur-deposit');
  const initialIkzeFormValues: IkzeExtendedEntrepreneurDepositAgreementForm ={
    isEntrepreneur: false,
    nip: undefined,
    entrepreneurConsent: undefined,
  };

  const [ikzeExtendedFormData, setIkzeExtendedFormData] = useState<IkzeExtendedEntrepreneurDepositAgreementForm>(initialIkzeFormValues);

  if (productType !== ProductType.ikze) {
    return null;
  }

  const setIkzeExtendedFormDataInState = () => {
    dispatch(productWizardActions.setIsEntrepreneur(ikzeExtendedFormData.isEntrepreneur));
    dispatch(productWizardActions.setEntrepreneurNip(ikzeExtendedFormData.isEntrepreneur
                                                      ? ikzeExtendedFormData.nip
                                                      : undefined));
  };

  return (
      <Container maxWidth="xl">
        <ProductWizardTitle titleKey={Screen.TRANSFER_IKZE_ENTREPRENEUR.code}/>
        <Container fixed className={c.root}>
          <Box className={c.box}>
            <IkzeExtendedEntrepreneurDepositAgreement initialValues={initialIkzeFormValues}
                                                      handleChange={values => setIkzeExtendedFormData(values)}
                                                      handleValid={valid => setIkzeFormValid(valid)}
                                                      className={c.entrepreneurBox}/>
          </Box>
        </Container>
        <CartSumBar nextEnabled={ikzeFormValid} onNextClick={() => setIkzeExtendedFormDataInState()} showSum={false} backButtonText={t('select_another_fund')}/>
      </Container>
  );
};

export default TransferIkzeEntrepreneur;
